import React, { useState } from "react";
import Input from "sushiweb/InputTypes/Input";
import NoFooterModal from "../Common/NoFooterModal";
import { BottomSectionModal } from "../../constants/assets/containers";
import Button from "sushiweb/Button";
import Permission from "../Common/Permission";
import styles from "../../constants/assets/variables";
import PaginatedReactDropdown from "../Common/PaginatedReactDropdown";
import { addDays, isValidated, isValNull } from "../../utils";
import { bindActionCreators } from "redux";
import * as PendingDeductionAction from "../../store/actions/PendingDeduction";
import { connect } from "react-redux";
import * as UserActions from "../../store/actions/User";
import Capitalize from "lodash-es/capitalize";
const mandatoryFields = ["driverId", "startDate", "endDate"];
const MAX_DAYS = 89;
const enableOptions = [
  { key: true, label: "True" },
  { key: false, label: "False" },
];
const PendingDeductionModal = (props) => {
  const toDateString = (date) => {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];
  };

  const {
    modalState,
    handleClose,
    currentPage,
    activeFilters,
    setStatus,
    getPendingDeductionList,
    setPendingDeductionActiveFilters,
  } = props;
  const [currentDate, setCurrentDate] = useState();
  const [initialState, setInitialState] = React.useState({
    driverId: "",
    pending: null,
    startDate: toDateString(new Date(Date.now() - MAX_DAYS * 24 * 3600 * 1000)),
    endDate: toDateString(new Date(Date.now())),
  });

  React.useEffect(() => {
    setCurrentDate(new Date().toISOString().substring(0, 10));
    setInitialStateObjectValues(activeFilters);
  }, [activeFilters]);

  const setInitialStateObjectValues = (obj) => {
    if (Object.keys(obj).length > 0) {
      let values = { ...initialState };
      Object.keys(values).map((item, index) => {
        if (!isValNull(obj[item])) {
          values[item] = obj[item];
        }
      });
      setInitialState(values);
    }
  };
  const handleSubmit = () => {
    const validation = isValidated(initialState, mandatoryFields);
    if (validation === "validated") {
      if (initialState["startDate"] && initialState["endDate"]) {
        let endDate = new Date(initialState["endDate"]);
        let startDate = new Date(initialState["startDate"]);
        if (startDate > endDate) {
          setStatus({
            type: "error",
            message: "Start date should come before end date",
          });
          return;
        } else {
          let maxPossibleDate = addDays(initialState.startDate, MAX_DAYS);
          if (endDate > maxPossibleDate) {
            setStatus({
              type: "error",
              message:
                "Maximum range of " +
                (MAX_DAYS + 1) +
                " days allowed, please modify dates",
            });
            return;
          }
        }
      }
      getPendingDeductionList(currentPage, initialState).then((res) => {
        handleClose();
      });
    } else {
      setStatus({
        type: "error",
        message: Capitalize(validation),
      });
    }
  };
  const handleClearFilters = () => {
    setPendingDeductionActiveFilters({});
    handleClose();
  };
  const getRequiredButtonPerms = () => {};
  const handleChange = (key, value) => {
    setInitialState((prevState) => {
      return { ...prevState, [key]: value };
    });
  };
  const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find((item) => {
      return item[fromKey] === (isNumber ? parseInt(val) : val);
    });
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };
  const getModalButtons = () => {
    return (
      <BottomSectionModal className="flex items-center justify-between">
        {modalState === "Filter" ? (
          <Button
            data-testid="filterFeatureBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
          >
            Clear
          </Button>
        ) : (
          <Button
            data-testid="filterFeatureBtn"
            onClick={handleClose}
            className="sushi-btn"
          >
            Cancel
          </Button>
        )}
        <Permission requiredPerms={getRequiredButtonPerms()}>
          <Button
            data-testid="submitCallDeptButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            {modalState === "Filter" ? "Apply" : "Submit"}
          </Button>
        </Permission>
      </BottomSectionModal>
    );
  };
  return (
    <NoFooterModal
      header={true}
      heading={`${modalState} Pending Deduction`}
      handleClose={handleClose}
      id="PendingDeductionModal"
      modalButtons={getModalButtons()}
    >
      <Input
        value={initialState.driverId}
        data-testid="pendingDeductionDriverId"
        id="sushi-input"
        onChange={(e) => handleChange("driverId", e)}
        label="Driver FE ID"
      />
      <Input
        max={currentDate}
        id="sushi-input"
        borderColor={styles.primaryColor}
        label="Start Date"
        type="date"
        value={initialState.startDate ? initialState.startDate : "  "}
        onChange={(e) => handleChange("startDate", e)}
        fullWidth={true}
      />
      <Input
        max={currentDate}
        id="sushi-input"
        label="End Date"
        type="date"
        value={initialState.endDate ? initialState.endDate : "  "}
        onChange={(e) => handleChange("endDate", e)}
        fullWidth={true}
        borderColor={styles.primaryColor}
      />
      <PaginatedReactDropdown
        options={enableOptions}
        data-testid="pendingDeductionPending"
        value={getInputLabel(
          initialState.pending,
          enableOptions,
          "key",
          "label"
        )}
        labelWidth="20%"
        labelKey="label"
        valueKey="key"
        handleChange={handleChange}
        keyToChange="pending"
        placeholder="Pending"
        showCross={true}
        id="pendingDeductionPending"
      />
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { PendingDeduction } = state;
  return {
    currentPage: PendingDeduction.currentPage,
    activeFilters: PendingDeduction.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getPendingDeductionList: bindActionCreators(
      PendingDeductionAction.getPendingDeductionList,
      dispatch
    ),
    setPendingDeductionActiveFilters: bindActionCreators(
      PendingDeductionAction.setPendingDeductionActiveFilters,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PendingDeductionModal);
